/* Habitual Product Hero: gallery, purchase toggle, pack selector, AJAX add-to-cart.
 * Per-product data comes from the inline <script data-ph-config> next to the section. */
(function () {
  function initRoot(root) {
    if (!root || root.__phInit) return;
    root.__phInit = true;

    var cfgEl = root.querySelector('[data-ph-config]');
    var cfg = {};
    if (cfgEl) {
      try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (_) { cfg = {}; }
    }
    var firstSpId    = cfg.firstSpId != null ? cfg.firstSpId : '';
    var discountPct  = typeof cfg.discountPct === 'number' ? cfg.discountPct : 10;
    var variants     = Array.isArray(cfg.variants) ? cfg.variants : [];

    var variantMap = {};
    variants.forEach(function (v) { variantMap[v.id] = v; });

    function formatMoney(cents) {
      return (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    }

    // ── Gallery ──
    var mainImg = root.querySelector('[data-ph-main-img] img');
    var mainWrap = root.querySelector('[data-ph-main-img]');
    var benefitBadge = mainWrap && mainWrap.querySelector('.hbb');
    root.querySelectorAll('[data-ph-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-ph-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        if (mainImg) {
          mainImg.src = this.dataset.phImgSrc;
          mainImg.srcset = this.dataset.phImgSrcset;
          mainImg.alt = this.dataset.phImgAlt || '';
        }
        if (benefitBadge) {
          benefitBadge.style.display = this.dataset.phThumb === '0' ? '' : 'none';
        }
      });
    });

    // ── Purchase toggle (one-time / subscription) ──
    var spInput      = root.querySelector('[data-ph-sp-input]');
    var variantInput = root.querySelector('[data-ph-variant-input]');
    var onetimePrice = root.querySelector('[data-ph-onetime-price]');
    var subPrice     = root.querySelector('[data-ph-sub-price]');
    var atcBtn       = root.querySelector('.ph-atc-btn');

    root.querySelectorAll('[data-ph-purchase]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        root.querySelectorAll('[data-ph-purchase]').forEach(function (o) { o.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (spInput) {
          spInput.value = this.dataset.phPurchase === 'subscription' ? firstSpId : '';
        }
      });
    });

    // ── Pack selector ──
    function updatePrices(variant) {
      var price = variant.price;
      var subNet = Math.round(price * (1 - discountPct / 100));
      if (onetimePrice) onetimePrice.textContent = formatMoney(price);
      if (subPrice) subPrice.textContent = formatMoney(subNet);
      root.querySelectorAll('[data-ph-pack-price]').forEach(function (el) {
        var packId = parseInt(el.closest('[data-ph-pack]').dataset.phPack);
        var v = variantMap[packId];
        if (v) el.textContent = formatMoney(v.price);
      });
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Beställ riskfritt' : 'Slut';
      }
    }

    root.querySelectorAll('[data-ph-pack]').forEach(function (pack) {
      pack.addEventListener('click', function () {
        root.querySelectorAll('[data-ph-pack]').forEach(function (p) { p.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        var vid = parseInt(this.dataset.phPack);
        if (variantInput) variantInput.value = vid;
        var variant = variantMap[vid];
        if (variant) {
          updatePrices(variant);
          var url = new URL(window.location.href);
          url.searchParams.set('variant', vid);
          history.replaceState(null, '', url.toString());
        }
      });
    });

    // ── Accordion ──
    root.querySelectorAll('.ph-accordion-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = this.closest('.ph-accordion');
        var isOpen = acc.classList.contains('is-open');
        root.querySelectorAll('.ph-accordion').forEach(function (a) {
          a.classList.remove('is-open');
          a.querySelector('.ph-accordion-trigger').setAttribute('aria-expanded', 'false');
          a.querySelector('.ph-accordion-body').setAttribute('aria-hidden', 'true');
        });
        if (!isOpen) {
          acc.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          acc.querySelector('.ph-accordion-body').setAttribute('aria-hidden', 'false');
        }
      });
    });

    // Phones: reviews start open so shoppers see them without a tap.
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      var revAcc = root.querySelector('.ph-accordion-reviews');
      if (revAcc) {
        revAcc.classList.add('is-open');
        revAcc.querySelector('.ph-accordion-trigger').setAttribute('aria-expanded', 'true');
        revAcc.querySelector('.ph-accordion-body').setAttribute('aria-hidden', 'false');
      }
    }

    // ── AJAX add-to-cart → opens Habitual cart drawer ──
    var form = root.querySelector('[data-ph-form]');
    var atcError = root.querySelector('[data-ph-atc-error]');
    function showAtcError(msg) {
      if (!atcError) return;
      atcError.textContent = msg || 'Något gick fel och varan lades inte i varukorgen. Försök igen, eller mejla info@habitual.se så hjälper vi dig.';
      atcError.hidden = false;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcError) atcError.hidden = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        var url = (window.Shopify && Shopify.routes) ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
        fetch(url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: fd
        }).then(function (r) { return r.json(); }).then(function (resp) {
          if (resp.errors || resp.status) {
            showAtcError(resp.description || (typeof resp.errors === 'string' ? resp.errors : ''));
            return;
          }
          // ── Set gclid as cart attribute via /cart/update.js ──
          // /cart/add.js silently ignores attributes[] — must use update.js instead.
          try {
            var _g = localStorage.getItem('habitual_gclid');
            var _gt = parseInt(localStorage.getItem('habitual_gclid_ts') || '0');
            if (_g && (Date.now() - _gt) < 60 * 24 * 60 * 60 * 1000) {
              var updateUrl = (window.Shopify && Shopify.routes) ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js';
              fetch(updateUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ attributes: { gclid: _g } })
              });
            }
          } catch (_e) {}
          document.dispatchEvent(new CustomEvent('habitual:cart:add', { detail: resp }));
          if (window.gtag) {
            gtag('event', 'add_to_cart', {
              currency: 'SEK',
              value: resp.price / 100,
              items: [{
                item_id: resp.sku || String(resp.id || ''),
                item_name: resp.product_title || resp.title,
                item_variant: (resp.variant_title && resp.variant_title !== 'Default Title') ? resp.variant_title : '',
                price: resp.price / 100,
                quantity: resp.quantity || 1
              }]
            });
          }
          if (resp.sections) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && resp.sections['cart-icon-bubble']) {
              bubble.innerHTML = new DOMParser().parseFromString(resp.sections['cart-icon-bubble'], 'text/html').body.innerHTML;
            }
          }
          if (atcBtn) atcBtn.textContent = '\u2713 Tillagd!';
          setTimeout(function () {
            if (atcBtn) atcBtn.textContent = 'Beställ riskfritt';
          }, 2000);
        }).catch(function () {
          showAtcError();
        });
      });
    }
  }

  // ── #reviews anchor smooth-scroll (was a separate tiny inline block) ──
  function scrollToReviews(e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href="#reviews"]') : null;
    if (!link) return;
    var target = document.querySelector('section[id^="pr-"]')
              || document.querySelector('.pr-wrap')
              || document.getElementById('reviews');
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    document.body.classList.remove('overflow-hidden');
    var rect = target.getBoundingClientRect();
    var top = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - 20;
    try { window.scrollTo({ top: top, behavior: 'smooth' }); }
    catch (err) {
      try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      catch (_) { window.scrollTo(0, top); }
    }
    if (history.replaceState) {
      try { history.replaceState(null, '', '#reviews'); } catch (_) {}
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ph-root]').forEach(initRoot);
    document.addEventListener('click', scrollToReviews, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
